import StatoAttivazione from './StatoAttivazione';

// eslint-disable-next-line import/prefer-default-export
export const CodiceServizioSerivizioPianoEccellenza = 'PDE';

export const CodiceServizioHelpdesk = 'HLP';

export function isServizioAttivo(profilo, codiceUfficio, codiceServizio) {
  if (!profilo) return false;

  const ufficio = profilo.Uffici.find(
    (x) => x.CodiceUfficio == parseInt(codiceUfficio, 10),
  );

  if (!ufficio || !ufficio.Servizi) return false;

  const servizio = ufficio.Servizi.find(
    (z) => z.CodiceServizio === codiceServizio,
  );

  if (!servizio) return false;

  return servizio.StatoAttivazione === StatoAttivazione.Attivo;
}
